import Server from './../../libs/server'
import Vue from 'vue';

import Moment from 'moment';

const state = {
    // epg: {
    //     programs: [],
    //     channel: null,
    //     date: Moment().locale('ru'),
    // },
    epgChannel: false,
    epgDate: Moment().locale('ru'),
    epgList: [],
    currentProgram: false,
    nextProgram: false,
    nowUTC: Math.trunc(Date.now() / 1000)
};

const actions = {
    getEpg({commit, dispatch, state}) {
        return new Promise((resolve, reject) => {
            Server.getEpg(state.epgChannel.id, state.epgDate.format('DDMMYY'), (err, data) => {
                if (err) {
                    console.error(err.message);
                    reject(err.message);
                } else {
                    if (data.error) {
                        reject(data.error);
                    }
                    else {
                        let programEmpty = data.epg.find(el => el.progname === 'Программа передач отсутствует.');
                        if (programEmpty) data.epg = [];

                        commit('SET_EPG_LIST', data.epg);
                        dispatch('updateEpg');
                        resolve();
                    }
                }
            })
        });
    },

    setEpgChannel({commit, dispatch}, channel) {
        return new Promise(resolve => {
            commit('SET_EPG_CHANNEL', channel);

            resolve();
        });
    },

    updateEpg({commit, dispatch, rootState}) {
        commit('UPDATE_NOW_UTC', +rootState.login.account.settings.timeshift.value);
    },
    changeEpgDate({commit, dispatch}, {days, epgDate}) {
        if (days === undefined) {
            commit('SET_EPG_DATE', epgDate);
        }
        else {
            if (days > 0) {
                commit('SET_EPG_DATE_NEXT');
            }
            else {
                commit('SET_EPG_DATE_PREVIOUS');
            }
        }
    },

    setProgramEnd({commit, dispatch}, {index, utEnd}) {
        commit('SET_PROGRAM_END', {index, utEnd});
    },
    setCurrentProgram({commit, dispatch}, program) {
        commit('SET_CURRENT_PROGRAM', program);
    },
    setNextProgram({commit, dispatch}, program) {
        commit('SET_NEXT_PROGRAM', program);
    }
};

const mutations = {
    SET_EPG_LIST(state, epgList) {
        state.epgList = epgList;
    },

    SET_EPG_CHANNEL(state, channel) {
        state.epgChannel = channel;
    },

    UPDATE_NOW_UTC(state, timeshiftValue) {
        state.nowUTC = Math.trunc((Date.now() - (timeshiftValue * 60 * 60 * 1000)) / 1000);
    },

    SET_PROGRAM_END(state, {index, utEnd}) {
        // console.log(state.epgList.find(val => val === program));
        // let programIndex = state.epgList.findIndex(value => value === program);
        Vue.set(state.epgList[index], 'ut_end', utEnd);
    },
    SET_CURRENT_PROGRAM(state, program) {
        state.currentProgram = program;
    },
    SET_NEXT_PROGRAM(state, program) {
        state.nextProgram = program;
    },

    SET_EPG_DATE(state, epgDate) {
        state.epgDate = epgDate;
    },
    SET_EPG_DATE_NEXT(state) {
        state.epgDate = state.epgDate.add(1, 'd');
    },
    SET_EPG_DATE_PREVIOUS(state) {
        state.epgDate = state.epgDate.subtract(1, 'd');
    }
};

export default {
    state,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/epg.js